module.exports = __webpack_public_path__ + "img/delete.fde7b9a2.png";